/**
 * This component display helps to route the page request to display information on the screen.
 *
 */
import React from 'react';
import { Route } from 'react-router-dom';
import Permission from 'spark-util/Permission';
import loadableModule from 'spark-views/main/loadableModule';
import { paths } from './adminRoutes';

const SafetyAdmin = loadableModule(() => import(/* webpackChunkName: "safetyAdmin" */ './index'));

const SafetyLetterAdminRoute = () => (
    <Permission requires="sm.safetyManagementModule">
        <Route path={paths.root} component={SafetyAdmin} />
    </Permission>
);

export default SafetyLetterAdminRoute;
